// import React, { useEffect, useState, useRef } from "react";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import { Doughnut } from "react-chartjs-2";
// import { adminAxios } from "../../axiosInstance";
// import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";
// import axios from "axios"
// // Register Chart.js components
// ChartJS.register(ArcElement, Tooltip, Legend);

// function ExpensesOverview({ currency }) {
//   const [expensesData, setExpensesData] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [selectedIndex, setSelectedIndex] = useState(null);
//   const chartRef = useRef(null);

//   // Dummy data in case there is no real data
//   const dummyExpenses = [
//     { name: "Office Supplies", value: 120 },
//     { name: "Expenses", value: 80 },
//     { name: "Sales", value: 150 },
//     { name: "Loan", value: 350 },
//   ];

//   useEffect(() => {
//     fetchExpensesData();
//     // eslint-disable-next-line
//   }, []);

 

//   const fetchExpensesData = async () => {
//   try {
//     const token = localStorage.getItem("myToken");
//     const response = await axios.get("https://01pos2.01technologies.net/api/admin/expenses", {
//       headers: { 
//         Authorization: `Bearer ${token}`, 
//         'Content-Type': 'application/json',  
//         'Accept': 'application/json' 
//       }
//     }); 

//     let rawData = response?.data?.data || [];

//     // Convert all expenses to monthly equivalent
//     const convertedData = rawData.map(item => {
//       let monthlyAmount = Number(item.amount) || 0;

//       if (item.type?.toLowerCase() === "daily") {
//         monthlyAmount = monthlyAmount * 30;
//       } else if (item.type?.toLowerCase() === "weekly") {
//         monthlyAmount = monthlyAmount * 4; // approx 4 weeks per month
//       } else if (item.type?.toLowerCase() === "yearly") {
//         monthlyAmount = monthlyAmount / 12;
//       }
//       // monthly stays the same

//       return {
//         ...item,
//         value: monthlyAmount,
//         name: item.category || item.name || "Uncategorized"
//       };
//     });

//     // Group by category/name and sum monthly amounts
//     const grouped = convertedData.reduce((acc, curr) => {
//       const key = curr.name;
//       if (!acc[key]) {
//         acc[key] = { name: key, value: 0 };
//       }
//       acc[key].value += curr.value;
//       return acc;
//     }, {});

//     const finalData = Object.values(grouped);

//     // Sort by value descending (largest first)
//     finalData.sort((a, b) => b.value - a.value);

//     setExpensesData(finalData.length > 0 ? finalData : dummyExpenses);
//   } catch (err) {
//     console.log("Error fetching expenses data", err);
//     setExpensesData(dummyExpenses);
//   } finally {
//     setIsLoading(false);
//   }
// };
//   // Prepare chart data
//   const chartData = {
//     labels: expensesData.map((item) => item.name),
//     datasets: [
//       {
//         data: expensesData.map((item) => item.value),
//         backgroundColor: [
//           "rgba(255, 99, 132, 0.8)",
//           "rgba(54, 162, 235, 0.8)",
//           "rgba(255, 206, 86, 0.8)",
//           "rgba(75, 192, 192, 0.8)",
//           "rgba(153, 102, 255, 0.8)",
//           "rgba(255, 159, 64, 0.8)",
//         ],
//         borderColor: [
//           "rgba(255, 99, 132, 1)",
//           "rgba(54, 162, 235, 1)",
//           "rgba(255, 206, 86, 1)",
//           "rgba(75, 192, 192, 1)",
//           "rgba(153, 102, 255, 1)",
//           "rgba(255, 159, 64, 1)",
//         ],
//         borderWidth: 2,
//         hoverOffset: 15,
//         offset: 5,
//         borderRadius: 8,
//         spacing: 2,
//       },
//     ],
//   };

//   // Chart options, with onClick to update selectedIndex
//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     cutout: "65%", // Makes it a doughnut (50% default, higher = thinner ring)
//     plugins: {
//       legend: {
//         display: false, // Hide the legend labels
//       },
//       tooltip: {
//         backgroundColor: "rgba(0, 0, 0, 0.8)",
//         padding: 12,
//         titleFont: {
//           size: 14,
//           weight: "bold",
//         },
//         bodyFont: {
//           size: 13,
//         },
//         callbacks: {
//           label: function (context) {
//             const label = context.label || "";
//             const value = context.parsed || 0;
//             const total = context.dataset.data.reduce((a, b) => a + b, 0);
//             const percentage = ((value / total) * 100).toFixed(1);
//             return `${label}: ${currency}${formatNumbersWithDecimal(value)} (${percentage}%)`;
//           },
//         },
//       },
//     },
//     animation: {
//       animateRotate: true,
//       animateScale: true,
//       duration: 1000,
//       easing: "easeInOutQuart",
//     },
//     // Attach onClick event to Doughnut chart
//     onClick: (event, elements) => {
//       if (elements && elements[0]) {
//         const index = elements[0].index;
//         setSelectedIndex(index);
//       } else {
//         setSelectedIndex(null);
//       }
//     },
//   };


  
//   // Choose what to display in the center
//   let centerTitle = "Total Expenses";
//   let centerValue = currency + formatNumbersWithDecimal(
//     expensesData.reduce((sum, item) => sum + item.value, 0)
//   );
//   let centerCategory = null;
//   if (
//     selectedIndex !== null &&
//     expensesData[selectedIndex]
//   ) {
//     const item = expensesData[selectedIndex];
//     centerTitle = item.name;
//     centerValue = currency + formatNumbersWithDecimal(item.value);
//     centerCategory = (
//       <span className="block text-sm text-gray-400 mt-1">
//         {(
//           (item.value /
//             expensesData.reduce((sum, i) => sum + i.value, 0)) *
//           100
//         ).toFixed(1)}
//         % of total
//       </span>
//     );
//   }

//   if (isLoading) {
//     return (
//       <div className="flex flex-col h-full min-w-0 bg-white rounded-lg gap-4 sm:gap-6 p-3 sm:p-4">
//         <h3 className="text-xl sm:text-2xl font-medium">Expenses Overview</h3>
//         <div className="flex flex-1 justify-center items-center min-h-[200px]">
//           <p>Loading...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="flex flex-col h-full min-w-0 bg-white rounded-lg gap-4 sm:gap-6 p-3 sm:p-4">
//       <h3 className="text-xl sm:text-2xl font-medium">Expenses Overview</h3>

//       {expensesData.length > 0 ? (
//         <div className="relative w-full h-[280px] sm:h-[340px] lg:h-[400px]">
//           <Doughnut ref={chartRef} data={chartData} options={options} />

//           {/* Center text overlay - will show details for selected or total */}
//           <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center pointer-events-none select-none">
//             <p className="text-sm text-gray-500 font-medium">{centerTitle}</p>
//             <p className="text-2xl font-bold text-gray-800">{centerValue}</p>
//             {centerCategory}
//           </div>
//         </div>
//       ) : (
//         <div className="flex flex-1 justify-center items-center min-h-[200px]">
//           <p className="text-gray-500">No expense data available</p>
//         </div>
//       )}
//     </div>
//   );
// }

// export default ExpensesOverview;


import React, { useEffect, useState, useRef } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";
import { adminAxios } from "../../axiosInstance";
// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const MONTH_NAMES = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

// Content slides in from the side the user navigated towards (skipped for reduced motion)
const ENTER_STYLES = `
@keyframes exp-enter-next { from { opacity: 0; transform: translateX(32px); } to { opacity: 1; transform: none; } }
@keyframes exp-enter-prev { from { opacity: 0; transform: translateX(-32px); } to { opacity: 1; transform: none; } }
.exp-enter-next { animation: exp-enter-next 280ms cubic-bezier(0.23, 1, 0.32, 1) both; }
.exp-enter-prev { animation: exp-enter-prev 280ms cubic-bezier(0.23, 1, 0.32, 1) both; }
@media (prefers-reduced-motion: reduce) { .exp-enter-next, .exp-enter-prev { animation: none; } }
`;

const pad = (n) => String(n).padStart(2, "0");

// First and last day of the month as "YYYY-MM-DD" (same start_date/end_date params the Expenses filter uses)
const getYearRange = (year) => ({ start_date: `${year}-01-01`, end_date: `${year}-12-31` });

const PERIODS = [
  { key: "month", label: "Month" },
  { key: "year", label: "Year" },
];

const getMonthRange = ({ year, month }) => {
  const lastDay = new Date(year, month + 1, 0).getDate();
  return {
    start_date: `${year}-${pad(month + 1)}-01`,
    end_date: `${year}-${pad(month + 1)}-${pad(lastDay)}`,
  };
};

function ExpensesOverview({ currency }) {
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date();
    return { year: now.getFullYear(), month: now.getMonth() };
  });
  const [expensesData, setExpensesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [period, setPeriod] = useState("month");
  const [direction, setDirection] = useState("next");
  const [selectedIndex, setSelectedIndex] = useState(null);
  const chartRef = useRef(null);

  // Dummy data in case there is no real data
  const dummyExpenses = [
    { name: "Office Supplies", value: 0 },
    { name: "Expenses", value: 0 },
    { name: "Sales", value: 0 },
    { name: "Loan", value: 0 },
  ];

  const now = new Date();
  const isYearView = period === "year";
  const isCurrentPeriod = isYearView
    ? selectedMonth.year === now.getFullYear()
    : selectedMonth.year === now.getFullYear() && selectedMonth.month === now.getMonth();

  useEffect(() => {
    let ignore = false;
    fetchExpensesData(() => ignore);
    return () => {
      ignore = true;
    };
    // eslint-disable-next-line
  }, [selectedMonth, period]);

  const changePeriod = (next) => {
    if (next === period) return;
    setSelectedIndex(null);
    setPeriod(next);
  };

  const changeMonth = (delta) => {
    setSelectedIndex(null);
    setDirection(delta > 0 ? "next" : "prev");
    setSelectedMonth(({ year, month }) => {
      const d = isYearView ? new Date(year + delta, month, 1) : new Date(year, month + delta, 1);
      return { year: d.getFullYear(), month: d.getMonth() };
    });
  };

 

  const fetchExpensesData = async (isStale = () => false) => {
  try {
    setIsLoading(true);
    const response = await adminAxios.get("expenses", {
      params: isYearView ? getYearRange(selectedMonth.year) : getMonthRange(selectedMonth),
    });
    if (isStale()) return;

    let rawData = response?.data?.data || [];

    // Convert all expenses to monthly equivalent
    const convertedData = rawData.map(item => {
      let monthlyAmount = Number(item.amount) || 0;

      if (isYearView) {
        // Yearly view totals what was actually logged
      } else if (item.type?.toLowerCase() === "daily") {
        monthlyAmount = monthlyAmount * 30;
      } else if (item.type?.toLowerCase() === "weekly") {
        monthlyAmount = monthlyAmount * 4; // approx 4 weeks per month
      } else if (item.type?.toLowerCase() === "yearly") {
        monthlyAmount = monthlyAmount / 12;
      }
      // monthly stays the same

      return {
        ...item,
        value: monthlyAmount,
        name: item.category || item.name || "Uncategorized"
      };
    });

    // Group by category/name and sum monthly amounts
    const grouped = convertedData.reduce((acc, curr) => {
      const key = curr.name;
      if (!acc[key]) {
        acc[key] = { name: key, value: 0 };
      }
      acc[key].value += curr.value;
      return acc;
    }, {});

    const finalData = Object.values(grouped);

    // Sort by value descending (largest first)
    finalData.sort((a, b) => b.value - a.value);

    setExpensesData(finalData.length > 0 ? finalData : dummyExpenses);
  } catch (err) {
    if (isStale()) return;
    console.log("Error fetching expenses data", err);
    setExpensesData(dummyExpenses);
  } finally {
    if (!isStale()) setIsLoading(false);
  }
};
  // Prepare chart data
  const chartData = {
    labels: expensesData.map((item) => item.name),
    datasets: [
      {
        data: expensesData.map((item) => item.value),
        backgroundColor: [
          "rgba(255, 99, 132, 0.8)",
          "rgba(54, 162, 235, 0.8)",
          "rgba(255, 206, 86, 0.8)",
          "rgba(75, 192, 192, 0.8)",
          "rgba(153, 102, 255, 0.8)",
          "rgba(255, 159, 64, 0.8)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 2,
        hoverOffset: 15,
        offset: 5,
        borderRadius: 8,
        spacing: 2,
      },
    ],
  };

  // Custom external tooltip handler
  const externalTooltipHandler = (context) => {
    // Tooltip Element
    let tooltipEl = document.getElementById('chartjs-tooltip');

    // Create element on first render
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'chartjs-tooltip';
      tooltipEl.style.opacity = 0;
      tooltipEl.style.pointerEvents = 'none';
      tooltipEl.style.position = 'absolute';
      tooltipEl.style.transform = 'translate(-50%, 0)';
      tooltipEl.style.transition = 'all .1s ease';
      tooltipEl.style.padding = '8px 12px';
      tooltipEl.style.backgroundColor = 'rgb(0, 0, 0)'; // Opaque black
      tooltipEl.style.color = 'white';
      tooltipEl.style.borderRadius = '4px';
      tooltipEl.style.fontSize = '12px';
      tooltipEl.style.zIndex = '9999';
      document.body.appendChild(tooltipEl);
    }

    // Hide if no tooltip
    const tooltipModel = context.tooltip;
    if (tooltipModel.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return;
    }

    // Set content
    if (tooltipModel.body) {
      const titleLines = tooltipModel.title || [];
      const bodyLines = tooltipModel.body.map(b => b.lines);

      let innerHtml = '<div>';

      // Title (name)
      titleLines.forEach(function(title) {
        const color = tooltipModel.labelColors[0].backgroundColor;
        innerHtml += `<div style="display: flex; align-items: center; margin-bottom: 4px;">
          <span style="display: inline-block; width: 12px; height: 12px; background-color: ${color}; margin-right: 6px;"></span>
          <span>${title}</span>
        </div>`;
      });

      // Body ("click to see more")
      bodyLines.forEach(function(body, i) {
        innerHtml += '<div>Click to see more</div>';
      });

      innerHtml += '</div>';
      tooltipEl.innerHTML = innerHtml;
    }

    // Display, position, and set styles for font
    const position = context.chart.canvas.getBoundingClientRect();
    tooltipEl.style.opacity = 1;
    tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
    tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
    tooltipEl.style.font = tooltipModel.options.bodyFont.string;
    tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
  };

  // Chart options, with onClick to update selectedIndex
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "65%", // Makes it a doughnut (50% default, higher = thinner ring)
    plugins: {
      legend: {
        display: false, // Hide the legend labels
      },
      tooltip: {
        enabled: false, // Disable built-in tooltip
        external: externalTooltipHandler, // Use custom external tooltip
      },
    },
    animation: {
      animateRotate: true,
      animateScale: true,
      duration: 1000,
      easing: "easeInOutQuart",
    },
    // Attach onClick event to Doughnut chart
    onClick: (event, elements) => {
      if (elements && elements[0]) {
        const index = elements[0].index;
        setSelectedIndex(index);
      } else {
        setSelectedIndex(null);
      }
    },
  };

  // Choose what to display in the center
  let centerTitle = "Total Expenses";
  let centerValue = currency + formatNumbersWithDecimal(
    expensesData.reduce((sum, item) => sum + item.value, 0)
  );
  let centerCategory = null;
  if (
    selectedIndex !== null &&
    expensesData[selectedIndex]
  ) {
    const item = expensesData[selectedIndex];
    const color = chartData.datasets[0].backgroundColor[selectedIndex];
    const total = expensesData.reduce((sum, i) => sum + i.value, 0);
    const percentage = ((item.value / total) * 100).toFixed(1);
    centerTitle = (
      <div className="flex items-center justify-center">
        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: color, color:"black", marginRight: '6px' }}></span>
        {item.name}
      </div>
    );
    centerValue = currency + formatNumbersWithDecimal(item.value);
    centerCategory = (
      <span className="block text-sm text-black mt-1">
        {percentage}% of total
      </span>
    );
  }

  const monthNavigator = (
    <div className="flex items-center justify-center gap-4">
      <button
        onClick={() => changeMonth(-1)}
        className="px-3 py-1 rounded border border-gray-400 hover:bg-gray-100"
        aria-label={isYearView ? "Previous year" : "Previous month"}
      >
        &lt;
      </button>
      <span
        key={`${period}-${selectedMonth.year}-${selectedMonth.month}`}
        className={`font-semibold min-w-[120px] sm:min-w-[160px] text-center exp-enter-${direction}`}
      >
        {isYearView ? selectedMonth.year : `${MONTH_NAMES[selectedMonth.month]} ${selectedMonth.year}`}
      </span>
      <button
        onClick={() => changeMonth(1)}
        disabled={isCurrentPeriod}
        className="px-3 py-1 rounded border border-gray-400 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label={isYearView ? "Next year" : "Next month"}
      >
        &gt;
      </button>
    </div>
  );

  return (
    <div className="flex flex-col h-full min-w-0 bg-white rounded-lg gap-4 sm:gap-6 p-3 sm:p-4">
      <style>{ENTER_STYLES}</style>
      <h3 className="text-xl sm:text-2xl font-medium">Expenses Overview</h3>
      <div className="flex justify-center">
        <div className="inline-flex w-full max-w-sm rounded-xl bg-gray-100 p-1" role="tablist">
          {PERIODS.map(({ key, label }) => (
            <button
              key={key}
              role="tab"
              aria-selected={period === key}
              onClick={() => changePeriod(key)}
              className={`flex-1 px-4 py-1.5 rounded-lg text-sm font-semibold transition-colors ${
                period === key ? "bg-blue-600 text-white" : "text-gray-600 hover:bg-gray-200"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      {monthNavigator}

      {isLoading ? (
        <div className="flex flex-1 justify-center items-center min-h-[200px]">
          <p>Loading...</p>
        </div>
      ) : expensesData.length > 0 ? (
        <div className={`relative w-full h-[280px] sm:h-[340px] lg:h-[400px] exp-enter-${direction}`}>
          <Doughnut ref={chartRef} data={chartData} options={options} />

          {/* Center text overlay - will show details for selected or total */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center pointer-events-none select-none bg-white p-2 sm:p-4 rounded-md text-black max-w-[55%]">
            <p className="text-sm font-medium">{centerTitle}</p>
            <p className="text-lg sm:text-2xl font-bold break-words">{centerValue}</p>
            {centerCategory}
          </div>
        </div>
      ) : (
        <div className="flex flex-1 justify-center items-center min-h-[200px]">
          <p className="text-gray-500">No expense data available</p>
        </div>
      )}
    </div>
  );
}

export default ExpensesOverview;